module.exports = __webpack_public_path__ + "static/media/arrowup.66b000a4.svg";